
import headerTitle from "@/components/block/components/header.vue";
import footMore from "@/components/block/components/footMore.vue";
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

export default {
components: {
headerTitle,
Icon,
footMore
},
props: {
listsData: {
type: Object,
required: true
},
blocktitleClass: {
type: String,
required: false
},
moreClass: {
type: String,
required: false
},
showMore: {
type: Boolean,
required: false,
default: true
},
moreNumber: {
type: Number,
require: false,
default: 9
}
},
data() {
return {
appid: this.$appid,
iconAuthor: require("@/assets/image/icon/icon_author.png"),
iconCart: require("@/assets/image/icon/icon_cart.png"),
iconSound: require("@/assets/image/icon/icon_sound.png"),
openNewWindows: true,
targetL: {

column: {
path: "detail",
params: [{ name: "id", label: "id"}] 
},
video: {
path: "videoDetail",
params: [{ name: "id", label: "id"}]
},
audio: {
path: "audioDetail",
params: [{ name: "id", label: "id"}]
},
ebook: {
path: "ebookDetail",
params: [{ name: "id", label: "id"}]
}
}
};
},
watch: {

},
methods: {
gotoTarget2(ind) {
let item = this.listsData.items[ind].bookRel;

let types = item.columnCode; 
let dataType = item.dataType; 
let target = this.targetL[types];
if(dataType == 'medialist'){
target = this.targetL['column'];
}else{
target = this.targetL[types];
}

if (target == undefined) {


return;
}
let pArr = target.params;
let q = {};
let obj = {};
obj["path"] = target.path;

pArr.forEach(p => {
let val = item[p.name];

let key = p.label ? p.label : p.name;
q[key] = val;
});

obj["query"] = q;



if (types == "audio") {
if (this.openNewWindows) {

obj.router = this.$router;
obj.path = this.$utils.splitUrl(obj.path);
obj.isTransWindows = true;
this.GLOBAL_.ccApp.openTo(obj);
} else {

this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
}

} else if (types == "ebook") {

obj.router = this.$router;
obj.path = this.$utils.splitUrl(obj.path);

this.GLOBAL_.ccApp.openTo(obj);
} else {
if (this.openNewWindows) {

obj.router = this.$router;
obj.path = this.$utils.splitUrl(obj.path);
obj.isTransWindows = true;
this.GLOBAL_.ccApp.openTo(obj);
} else {

this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
}
}
}
},
mounted() {


}
};



// WEBPACK FOOTER //
// ./src/components/block/ninePalaces.vue